/** @file Returns a cached stage value while its dependency list is unchanged, else computes and stores it. */
import type { MemoEntry } from './compileCache';
import { sameDeps } from './sameDeps';

/** Anything keyed like a Map or a WeakMap that holds memo entries. */
export type MemoStore<K> = { get(key: K): MemoEntry | undefined; set(key: K, entry: MemoEntry): unknown };

/** Cached value of `key` when its deps equal `deps`; otherwise runs `compute`, stores and returns it (a throw stores nothing). */
export function memoStage<K, T>(store: MemoStore<K>, key: K, deps: readonly unknown[], compute: () => T): T {
  const hit = store.get(key);
  if (hit && sameDeps(hit.deps, deps)) return hit.value as T;
  const value = compute();
  store.set(key, { deps, value });
  return value;
}
